import axios from 'axios';

export default {
  name: 'projectPhases',
  props: ['doc', 'project'],
  data () {
    return {
      Request: {
        FullFileName: '',
      },
      fileType: '',
      upload: false,
      uploaded: false,
      isFailed: false,
    };
  },
  methods: {
    /**
         * This method uploads the file to the server
         * Please, check its working. Make validation uploaded file formats
         * through through files extensions.
         * Please, make view of this template more user friendly
         * If you want to learn more about the work logic, please chek the
         * ProjectPackageController
         */
    FileUploadedHeandler (event) {
      var formData = new FormData();
      var files = event.target.files;
      this.upload = true;
      if (files.length > 0) {
        formData.append('somefile', files[0]);
      } else { return; }
      axios.post(this.$store.getters.rootAPI + '/uploadProjectFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'File-Data': `0,${this.doc.FileName},${this.project.GroupName}`,
          'Project-Derectory': `${this.doc.FullFileName}`,
        },
      }).then((response) => {
        if (response.data.status) {
          this.doc.FullFileName = response.data.fullFileName;
          this.doc.DownloadLink = response.data.Link;
          this.upload = false;
          this.uploaded = true;
        }
      });
    },

    /**
         * This method should delete file from server
         * if user wants change current file
         * Request Url /removeUploadedFile
         * You should pass to server Request Project (check structure on Post Data)
         * with FullFileName string.
         */
    DeleteUploadedFile () {
      this.Request.FullFileName = this.doc.FullFileName;
      var fileData = {
        Request: {
          FullFileName: this.doc.FullFileName,
        } };
      axios.post(this.$store.getters.rootAPI + '/removeUploadedFile', fileData).then((response) => {
        this.uploaded = false;
        this.upload = false;
        this.doc.FullFileName = this.project.ProjectGroupPackage.FullFileName;
        this.doc.DownloadLink = '';
      });
    },
  },
  mounted () {
    this.fileType = '.' + this.doc.FileType;
  },
};
